import React from 'react';
import InputBase from 'components/Inputs/InputBase';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useFormikContext } from 'formik';

interface Props {
  name: string;
  label?: string;
  helperText?: string | null;
  disabled?: boolean;
}

const InputPhone: React.FC<Props> = ({ name, label, helperText, disabled }) => {
  const { setFieldValue, getFieldProps, setFieldTouched } = useFormikContext();
  const handlePhoneInputChange = (newValue: string) => {
    setFieldValue(name, newValue);
  };
  const { value: phoneValue } = getFieldProps(name);

  return (
    <InputBase label={label} name={name} helperText={helperText}>
      <PhoneInput
        value={phoneValue}
        onChange={handlePhoneInputChange}
        regions={['america', 'europe']}
        country="ar"
        enableSearch
        inputClass="inputPhone"
        onBlur={() => setFieldTouched(name)}
        searchStyle={{ width: '90%', height: '30px' }}
        disabled={disabled}
      />
    </InputBase>
  );
};

export default InputPhone;
